// extracted by mini-css-extract-plugin
module.exports = {"orderTracking":"order-tracking_orderTracking__qfIGS"};